/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Code_Invalid_ErrorInputs */

const en_login_page_code_invalid_error = /** @type {(inputs: Login_Page_Code_Invalid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code didn’t work. Check it and try again.`)
};

const de_login_page_code_invalid_error = /** @type {(inputs: Login_Page_Code_Invalid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Code hat nicht funktioniert. Prüfen Sie ihn und versuchen Sie es erneut.`)
};

const pt_br2_login_page_code_invalid_error = /** @type {(inputs: Login_Page_Code_Invalid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse código não funcionou. Confira e tente novamente.`)
};

const tr_login_page_code_invalid_error = /** @type {(inputs: Login_Page_Code_Invalid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kod çalışmadı. Kodu kontrol edip tekrar deneyin.`)
};

const zh_cn2_login_page_code_invalid_error = /** @type {(inputs: Login_Page_Code_Invalid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该验证码无效。请检查后重试。`)
};

const zh_hk2_login_page_code_invalid_error = /** @type {(inputs: Login_Page_Code_Invalid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該驗證碼無效。請檢查後再試。`)
};

const ko_kr2_login_page_code_invalid_error = /** @type {(inputs: Login_Page_Code_Invalid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코드가 올바르지 않습니다. 확인 후 다시 시도하세요.`)
};

const ru_ru2_login_page_code_invalid_error = /** @type {(inputs: Login_Page_Code_Invalid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот код не подошёл. Проверьте его и попробуйте снова.`)
};

const es_419_login_page_code_invalid_error = /** @type {(inputs: Login_Page_Code_Invalid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese código no funcionó. Revísalo e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "That code didn’t work. Check it and try again." |
*
* @param {Login_Page_Code_Invalid_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_code_invalid_error = /** @type {((inputs?: Login_Page_Code_Invalid_ErrorInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Code_Invalid_ErrorInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_code_invalid_error(inputs)
	if (locale === "de") return de_login_page_code_invalid_error(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_code_invalid_error(inputs)
	if (locale === "tr") return tr_login_page_code_invalid_error(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_code_invalid_error(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_code_invalid_error(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_code_invalid_error(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_code_invalid_error(inputs)
	return es_419_login_page_code_invalid_error(inputs)
});